// extracted by mini-css-extract-plugin
module.exports = {"ant-btn":"comment-button_ant-btn__Uzf4l","action-btn":"comment-button_action-btn__zbgmX","active":"comment-button_active__OcDmY","hover":"comment-button_hover__YQSTq"};